<template>
  <data-section
    theme="green"
    title="國泰產險-健康險"
    :isHealthInsurance="true"
    :datas="
      _.orderBy(
        highlightModify,
        ['familyrl', 'age', 'ceisdno', 'orderbBySelf', 'ceplcno'],
        ['asc', 'desc', 'asc', 'asc', 'asc']
      )
    "
    :_fields="
      [
        {
          name: '保單號碼',
          key: 'ceplcno',
          width: 115,
          sortable: true,
          orderByMultiKey: ['ceplcno'],
          orderByMultiType: ['asc']
        },
        {
          name: '險種',
          key: 'cepln_nm',
          width: 200,
          sortable: true,
          orderByMultiKey: ['cepln_nm'],
          orderByMultiType: ['asc']
        },
        {
          name: '要保人',
          key: 'ceapcnm',
          width: 80,
          sortable: true,
          orderByMultiKey: ['ceapcnm'],
          orderByMultiType: ['asc']
        },
        {
          name: '被保人',
          key: 'ceisdnm',
          width: 80,
          sortable: true,
          className: 'link text-underline',
          orderByMultiKey: ['ceisdnm'],
          orderByMultiType: ['asc']
        },
        {
          name: '出單日期',
          key: 'cepoldt',
          width: 96,
          sortable: true,
          orderByMultiKey: ['cepoldt'],
          orderByMultiType: ['asc']
        },
        {
          name: '有效期間',
          key: 'ceplcdt',
          width: 121,
          sortable: true,
          orderByMultiKey: ['ceplcdt'],
          orderByMultiType: ['asc']
        },
        {
          name: '保費',
          key: 'premium2',
          width: 90,
          sortable: true,
          thClassName: 'text-right',
          className: 'text-right',
          orderByMultiKey: ['premium2'],
          orderByMultiType: ['asc']
        },
        { name: '給付明細', key: 'detail', width: 131 }
      ].concat(_fields)
    "
    @toggle="
      (isShow) =>
        $router.assignQuery({ CathayPropertyHealthInsuranceShow: isShow })
    "
    :initShow="$route.query['CathayPropertyHealthInsuranceShow'] !== 'false'"
  >
    <template scope="props"  v-if="refresh">
      <data-table
        v-bind="props"
        @changeSort="
          (sort) =>
            $router.assignQuery({
              [`CathayPropertyHealthInsuranceSort`]: JSON.stringify(sort)
            })
        "
        :initSort="
          $route.query[`CathayPropertyHealthInsuranceSort`]
            ? JSON.parse($route.query[`CathayPropertyHealthInsuranceSort`])
            : null
        "
      >
        <template slot="ceplcno" scope="item">
          <span :class="{ 'text-blue': item.data.isKeyinBySelf }">{{
            item.data.ceplcno
          }}</span>
        </template>
        <template slot="ceapcnm" scope="item">
          <span>
            {{ item.data.ceapcnm | truncate }}
          </span>
        </template>
        <template slot="ceisdnm" scope="item">
          <span @click="routeToCustDetail(item.data.ceisdno,item.data.ceisdnm )">
            {{ item.data.ceisdnm | truncate }}
          </span>
        </template>
        <template slot="cepoldt" scope="item">
          {{ getROCDate(item.data.cepoldt) }}
        </template>
        <template slot="ceplcdt" scope="item">
          <div
            class="pre-formatted"
            v-html="
              buildStartEndString(
                getROCDate(item.data.ceplcdt) + ' ' + item.data.ceplcdt_time,
                getROCDate(item.data.celpsdt) + ' ' + item.data.celpsdt_time
              )
            "
          ></div>
        </template>
        <template slot="premium2" scope="item"
          >{{ item.data.premium2 | numberFormat }}元</template
        >
        <template slot="detail" scope="item">
          <div>
            {{ +item.data.type41 ? `• 住院日額：${item.data.type41}元` : "" }}
          </div>
          <div>
            {{
              +item.data.type51
                ? `• 特定重大疾病保險金：${item.data.type51}萬元`
                : ""
            }}
          </div>
          <div>
            {{
              +item.data.type61
                ? `• 初次罹癌保險金：${item.data.type61}萬元`
                : ""
            }}
          </div>
        </template>
        <template slot="action" scope="item">
          <a
            role="button"
            class="text-red text-underline"
            @click="doDelete(item.data)"
            >刪除</a
          >
        </template>
      </data-table>
    </template>
  </data-section>
</template>

<script>
import InsuranceMixins from "./Insurance";
import HighlightModify from "./HighlightModify";
import { deleteSelfInputPropertyNumber, getQuerySelfInputPropertyNumber } from "@/service";

export default {
  mixins: [InsuranceMixins, HighlightModify],
  methods: {
    async doDelete(data) {
      await this.$deleteConfirm(
        this.buildDeleteMessage(`${data.ceplcno} ${data.cepln_nm}`)
      );
      
      const result = await getQuerySelfInputPropertyNumber(
        this.$store.state.userInfo.id,
        data.ceisdno,
        data.ceplcno,
      );
      if (result.header && result.header.status === "200") {
          let selfData = result.body.dataList;
          data.pln = selfData.pln;
      }else{
          data.pln = "";
      }
      await this.deleteSuccessHandler(
        deleteSelfInputPropertyNumber(
          this.$store.state.userInfo.id,
          data.ceplcno,
          data.pln
        )
      );
      this.isLoading = true;
      this.$bus.emit(
        "cathay-health-insurance.get",
        () => (this.isLoading = false)
      );
    }
  }
};
</script>
